import { render, staticRenderFns } from "./regionCheckModal.vue?vue&type=template&id=8e5c125c&scoped=true&"
import script from "./regionCheckModal.vue?vue&type=script&lang=js&"
export * from "./regionCheckModal.vue?vue&type=script&lang=js&"
import style0 from "./regionCheckModal.vue?vue&type=style&index=0&id=8e5c125c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5c125c",
  null
  
)

export default component.exports